import './ergoMunicipalityCodeList.less';

import * as _ from 'lodash';

const validCodeRe = /^[0-9]{2}([0-9]{2})?$/;

class MunicipalityCodeListController {
    constructor() {
        this.isDisabled = false;
        this.onChange = null;
        this.list = [];
        this.editing = null;
        this.form = null;
    }

    /**
     * 
     * @param {string} value
     */
    render(value) {
        this.editing = null;

        if (_.isArray(value)) {
            if (!value.every(x => validCodeRe.test(x))) {
                throw 'Invalid municipality code list';
            }
            this.list = value.map(x => ({ code: x }));
        } else {
            this.list = [];
        }
    }

    publish() {
        if (this.onChange) {
            this.onChange(this.list.map(x => x.code));
        }
    }

    setDisabled(value) {
        this.isDisabled = !!value;
    }

    canAdd() {
        if (this.isDisabled) {
            return false;
        }

        if (this.editing != null && !this.canApply()) {
            return false;
        }

        return true;
    }

    add() {
        if (this.canAdd()) {
            this.list.push({ code: '' });
            this.editing = this.list[this.list.length - 1];
            this.applyfocus = true;
        }
    }

    isEditing(row) {
        return this.editing === row;
    }

    canEdit(_row) {
        return this.editing == null;
    }

    edit(row) {
        if (this.canEdit(row)) {
            this.editing = row;
            this.applyfocus = true;
        }
    }

    canApply() {
        return this.form != null && this.form.$valid;
    }

    apply() {
        if (this.canApply() && this.editing != null) {
            if (this.editing.code == null || this.editing.code === '' || _.some(this.list, x => x !== this.editing && x.code === this.editing.code)) {
                this.remove();
            } else {
                this.editing = null;
                this.publish();
                return true;
            }
        }
    }

    remove() {
        let pos = this.list.indexOf(this.editing);
        if (pos >= 0) {
            this.editing = null;
            this.list.splice(pos, 1);
            this.publish();
        }
    }

    onKeyDown($event) {
        if ($event.key === 'Enter') {
            if (this.editing != null) {
                if (this.apply()) {
                    this.add();
                }
            }
        }
    }

    onFocusOut($event) {
        if ($event.relatedTarget != null) {
            if ($event.currentTarget.contains($event.relatedTarget)) {
                return;
            }
        }

        this.apply();
    }
}

angular.module("tromanWeb").directive("ergoMunicipalityCodeList", [function () {
    return {
        restrict: "E",
        require: ['ergoMunicipalityCodeList', '?ngModel'],
        template: require('./ergoMunicipalityCodeList.html'),
        controller: MunicipalityCodeListController,
        controllerAs: '$ctrl',
        link: function (scope, _element, attributes, ctrls) {
            var ergoMunicipalityCodeList = ctrls[0];
            var ngModel = ctrls[1];

            if (ngModel) {
                ergoMunicipalityCodeList.onChange = (val) => {
                    ngModel.$setViewValue(val);
                };

                ngModel.$render = () => {
                    ergoMunicipalityCodeList.render(ngModel.$viewValue);
                };

                ngModel.$isEmpty = function (value) {
                    return value == null || value.length === 0;
                };
            }

            if (attributes.disabled) {
                scope.$watch(attributes.disabled, value => {
                    ergoMunicipalityCodeList.setDisabled(value);
                });
            }
        }
    };
}]);
